export default __webpack_public_path__ + "static/media/image_loader.5ef40d33.gif";